// extracted by mini-css-extract-plugin
module.exports = {"base":"CardLayout_base__7xYO2"};